module.exports = __webpack_public_path__ + "img/logo.22ef7a53.png";